import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import { pages } from "@/root/consts";
import { useAppSelector } from "@/hooks/redux";
import { CreateUserPage, LoginPage } from "@/pages";
import { Main } from "@/components";

const Router: FC = () => {
  const isAuth = useAppSelector((state) => Boolean(state.userReducer.userType));

  return (
    <Routes>
      <Route path={pages.createUser.path} element={<CreateUserPage />} />
      <Route path={pages.login.path} element={<LoginPage />} />
      <Route path="/*" element={isAuth && <Main />} />
    </Routes>
  );
};

export default Router;
